// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/zeit/a4bedf9/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-blog-post-js": () => import("/zeit/a4bedf9/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-pages-404-js": () => import("/zeit/a4bedf9/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/zeit/a4bedf9/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-talks-js": () => import("/zeit/a4bedf9/src/pages/talks.js" /* webpackChunkName: "component---src-pages-talks-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/zeit/a4bedf9/.cache/data.json")

